import { errorText, type ApiError } from '@mezha/api'
import { clockText } from './time'

const CURRENCY: Record<string, string> = { silver: 'серебра', crystal: 'кристаллов' }

/** The error text plus the numbers the server attached (level, price, moment). */
export function explain(e: ApiError): string {
  const base = errorText(e)
  const d = e.details
  switch (e.code) {
    case 'attribute_required': {
      const names: Record<string, string> = { str: 'Сила', vit: 'Стойкость', dex: 'Ловкость', wis: 'Мудрость', lck: 'Удача', kno: 'Знание' }
      return typeof d.need === 'number' && typeof d.have === 'number' ? `Нужно: ${names[String(d.attr)] ?? String(d.attr)} ${d.need} — у вас ${d.have}` : base
    }
    case 'level_required':
      return typeof d.level_required === 'number' ? `Нужен уровень ${d.level_required}` : base
    case 'insufficient_funds': {
      const cur = CURRENCY[String(d.currency)] ?? ''
      const need = typeof d.need === 'number' ? d.need : null
      const have = typeof d.have === 'number' ? d.have : null
      return need !== null ? `${base}: нужно ${need} ${cur}${have !== null ? `, есть ${have}` : ''}` : base
    }
    case 'insufficient_items':
      return typeof d.need === 'number' && typeof d.have === 'number' ? `${base}: нужно ${d.need}, есть ${d.have}` : base
    case 'use_limit_reached': {
      const at = e.at('ready_at')
      return at ? `${base} — снова можно в ${clockText(at)}` : base
    }
    case 'attribute_cap':
      return typeof d.cap === 'number' ? `${base} (${d.cap})` : base
    case 'rate_limited':
      return typeof d.retry_after_ms === 'number' ? `${base}: повторить через ${Math.ceil(d.retry_after_ms / 1000)} с` : base
    default: {
      const at = e.at('ready_at') ?? e.at('arrives_at') ?? e.at('until')
      return at ? `${base} — к ${clockText(at)}` : base
    }
  }
}
